import { Component, OnInit, HostListener, ViewChild, Input, DoCheck } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { AttendanceStudentStatistics } from '../../_models';
import { BaseComponent } from 'src/app/_base/base.component';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent extends BaseComponent implements OnInit, DoCheck {
  // protected bxSliderList: any;
  configurations: any;
  arrowDisplayer: boolean = true;
  @Input('backgroundColor') backgroundColor: string = '#ff8357';
  @Input('itemsList') itemsList: AttendanceStudentStatistics[];
  @ViewChild(PerfectScrollbarDirective)
  directiveRef?: PerfectScrollbarDirective;
  translate: TranslateService;
  constructor() {
    super();
  }
  ngDoCheck() {
    if (!this.directiveRef.scrollable('x')) {
      this.arrowDisplayer = false;
    } else {
      this.arrowDisplayer = true;
    }
  }
  ngOnInit() {
    this.configurations = {
      suppressScrollX: false
    };
    // this.bsSliderLoader();
  }
  goRight() {
    if (this.directiveRef.scrollable('x')) {
      this.directiveRef.scrollToX(this.directiveRef.geometry().x + 115, 300);
    }
  }
  goLeft() {
    if (this.directiveRef.scrollable('x')) {
      this.directiveRef.scrollToX(this.directiveRef.geometry().x - 115, 300);
    }
  }
  // bsSliderLoader(): void {
  //   this.bxSliderList = {
  //     currentIndex: 0,
  //     currentScreen: 0,
  //     maxShowItems: 0,
  //     itemsNumberOnXL: 0,
  //     itemsNumberOnLG: 0,
  //     itemsNumberOnMD: 0,
  //     itemsNumberOnSM: 0,
  //     itemsNumber: 0,
  //     numberOfMovements: 1,
  //     hideNavigatorOnEnd: true,
  //     itemsList: []
  //   };
  // }
  trackBy(item: any): any {
    return item.id;
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!this.directiveRef.scrollable('x')) {
      this.arrowDisplayer = false;
    } else {
      this.arrowDisplayer = true;
    }
    // if (window.innerWidth >= 1200) {
    //   this.bxSliderList.currentScreen = 0;
    // } else if (window.innerWidth < 1200 && window.innerWidth >= 992) {
    //   this.bxSliderList.currentScreen = 1;
    // } else if (window.innerWidth < 992 && window.innerWidth >= 768) {
    //   this.bxSliderList.currentScreen = 2;
    // } else if (window.innerWidth < 768 && window.innerWidth >= 576) {
    //   this.bxSliderList.currentScreen = 2;
    // } else if (window.innerWidth < 576) {
    //   this.bxSliderList.currentScreen = 4;
    // }
  }
  // bxSliderMove = function(situation) {
  //   if (situation === 'Increment') {
  //     if (this.bxSliderList.itemsList.length !== this.bxSliderList.MaxShowItems + this.bxSliderList.currentIndex) {
  //       this.bxSliderList.currentIndex += this.bxSliderList.numberOfMovements;
  //     }
  //   } else if (
  //     this.bxSliderList.CurrentIndex > this.bxSliderList.NumberOfMovements
  //   ) {
  //     this.bxSliderList.CurrentIndex -= this.bxSliderList.NumberOfMovements;
  //   }
  // };
}
